import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { AppMaterialModule } from 'src/app/app.material.module';
import { LoginRoutingModule } from './auth-routing.module';
import { Error404Component } from './error-404/error-404.component';
import { LoginComponent } from './login/login.component';


@NgModule({
  declarations: [LoginComponent, Error404Component],
  imports: [
    CommonModule,
    LoginRoutingModule,
    ReactiveFormsModule,
    MatIconModule,
    AppMaterialModule
  ]
})
export class AuthModule {
}